
import { slideShowApi } from "../../apis";
import Swal from "sweetalert2";




export const slideshowHomeprincipal = async () => {
    try {
        const { data } = await slideShowApi.get('/');
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}





export const slideshowCreateImagen = async (body) => {
    try {
        const formData = new FormData();
        if(body?.img && typeof body?.img !== 'string') { formData.append('images', body.img); }
        
        Object.entries(body).forEach(([key, value]) => {
            formData.append(key, value?.toString());
        });
        
        await slideShowApi.post('/new', formData);
        Swal.fire('Exitoso', 'Imagen Publicitaria Creada', 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}






export const eliminarSlideShow = async (id) => {
    try {
        const { data } = await slideShowApi.delete(`/${id}`);
        Swal.fire('Exitoso', data.msg, 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}